import React, { useEffect, useRef, useState } from "react";
import { AirbudsYearlyHeader } from "../component/storyHeader";
import { TypeAnimation } from "react-type-animation";

import { useNavigate } from "react-router";

import { motion, animate } from "motion/react";
import ShareableComponent from "../sharing";
import { randomNumber } from "../stats/statsIntro";
import EmojiWave, { defaultEmojis, questionEmojis } from "../compat/emojiWave";
import { StoryOverlay } from "../compat/compat";
import StoryProgressBar from "../component/pagination";
import ChatMessages from "./chatGhost";
import { Counter } from "../component/counter";
import { ActionButtonFull } from "../component/buttons";
import { ComebackMessage } from "../comebackToUnlock";
import { useData } from "../data/dataContext";
import { EmptyScreen } from "../validation/validation";

function useStateAndRef(initial) {
  const [value, setValue] = useState(initial);
  const valueRef = useRef(value);
  valueRef.current = value;
  return [value, setValue, valueRef];
}

export const CuriosityFlow = ({}) => {
  const { data } = useData();
  const [step, setStep, refStep] = useStateAndRef(0);
  const [reactionsList, setReactionsList] = useState(defaultEmojis);

  const navigate = useNavigate();
  const [categories, setCategories, refCategories] = useStateAndRef([]);

  useEffect(() => {
    if (data && data.reactions) {
      const reactions = data.reactions.sample
        .filter((reaction) => reaction.kind === "emoji")
        .map((reaction) => reaction.body);
      setReactionsList(reactions.concat(reactions));
    }
  }, [data]);

  const previous = () => {
    setStep(Math.max(refStep.current - 1, 0));
  };

  const next = () => {
    if (refStep.current == refCategories.current.length - 1) {
      navigate("/menu");
    } else {
      setStep(Math.min(refStep.current + 1, refCategories.current.length));
    }
  };

  if (!data) {
    return <p>Loading...</p>;
  }

  if (!data.weird_artist && !data.yingyang && !data.reactions) {
    return <EmptyScreen text="no data" closeAction={() => navigate("/menu")} />;
  }

  useEffect(() => {
    var c = [];

    if (data.weird_artist && data.weird_artist) {
      c.push({
        id: "weird-artist",
        type: "weird-artist",
      });
    }

    if (data.yingyang && data.yingyang.artist1) {
      c.push({
        id: "ying-yang-1",
        type: "ying-yang-1",
      });

      c.push({
        id: "ying-yang-2",
        type: "ying-yang-2",
      });
    }

    if (c.length == 0) {
      c.push({
        id: "reactions",
        type: "reactions",
      });

      c.push({
        id: "questions",
        type: "questions",
      });
    }

    c.push({
      id: "comeback-message",
      type: "comeback-message",
    });

    setCategories(c);
  }, [data]);

  const renderState = (ctgs, state) => {
    if (!ctgs || ctgs.length <= state) {
      return (
        <EmptyScreen text="loading..." closeAction={() => navigate("/menu")} />
      );
    }

    const stepId = ctgs[state].id;

    switch (stepId) {
      case "weird-artist":
        if (!data.weird_artist) {
          next();
        }

        return (
          <motion.div
            key="step-0"
            className="app-curiosity-content app-curiosity-content-chat"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <ChatMessages data={data.weird_artist} next={next} />
          </motion.div>
        );
      case "reactions":
        if (!data.reactions) {
          next();
        }

        return (
          <div>
            <EmojiWave emojis={reactionsList} next={() => {}} />
            <motion.div
              key="step-1"
              className="app-curiosity-content"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 0, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              <div className="column-layout">
                <Counter
                  className="headline counter-big"
                  from={0}
                  to={data.reactions.count}
                  duration={3}
                />
                <h2>Reactions</h2>
                <h3 className="light-headline">Sent & received</h3>
              </div>
            </motion.div>
          </div>
        );
      case "questions":
        if (
          !data.prompt_stats ||
          data.prompt_stats.answers_count == null ||
          data.prompt_stats.prompts_count != null
        ) {
          next();
        }

        return (
          <div>
            <EmojiWave
              key="question-emojis"
              emojis={questionEmojis}
              next={() => {}}
            />
            <motion.div
              key="step-2"
              className="app-curiosity-content"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 0, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              <div className="column-layout">
                <Counter
                  className="headline counter-big"
                  from={0}
                  to={
                    data.prompt_stats.answers_count +
                    data.prompt_stats.prompts_count
                  }
                  duration={3}
                />
                <h2>Questions</h2>
                <h3 className="light-headline">sent & answered</h3>
              </div>
            </motion.div>
          </div>
        );

      case "ying-yang-1":
        if (data.yingyang != null && !data.yingyang && !data.yingyang.artist1) {
          next();
        }
        return (
          <motion.div
            key="step-3"
            className="app-curiosity-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <div className="column-layout curiosity-column ">
              <motion.p
                key="step-3p-key"
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: "0%" }}
                exit={{ opacity: 1, y: "-100%" }}
                transition={{
                  duration: 1.0,
                  delay: 0.0,
                  ease: [0, 0.71, 0.2, 1.01],
                }}
              >
                Out of your top artists
              </motion.p>

              <motion.h3
                key="step-3h-key"
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: "0%" }}
                exit={{ opacity: 1, y: "-100%" }}
                transition={{
                  duration: 1.0,
                  delay: 1.5,
                  ease: [0, 0.71, 0.2, 1.01],
                }}
                className="headline-light"
              >
                these two were the most different from each other
              </motion.h3>
            </div>
          </motion.div>
        );

      case "ying-yang-2":
        if (data.yingyang != null && !data.yingyang && !data.yingyang.artist1) {
          next();
        }
        return (
          <div>
            <motion.div
              key="step-5"
              className="app-curiosity-content app-curiosity-yingyang"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 0, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              <div className="yy-center-content">
                <motion.h1
                  key="step-4h1-key"
                  initial={{ opacity: 0, y: "100%" }}
                  animate={{ opacity: 1, y: "0%" }}
                  exit={{ opacity: 1, y: "-100%" }}
                  transition={{
                    duration: 1.0,
                    delay: 1.5,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className="curiosity-artist-name"
                >
                  {data.yingyang.artist1.name}
                </motion.h1>

                <motion.div
                  className="yingyang"
                  initial={{
                    rotate: "0deg",
                  }}
                  animate={{
                    rotate: "180deg",
                  }}
                  exit={{
                    rotate: "360deg",
                  }}
                  transition={{
                    repeat: 3,
                    repeatType: "mirror",
                    duration: 2.0,
                    delay: 4.0,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                >
                  <motion.img
                    key="ying"
                    initial={{
                      opacity: 0,
                      x: "-100%",
                    }}
                    animate={{
                      opacity: 1,
                      x: "0%",
                    }}
                    exit={{
                      opacity: 1,
                      x: "-100%",
                    }}
                    transition={{
                      duration: 1.0,
                      delay: 0.5,
                      ease: [0, 0.71, 0.2, 1.01],
                    }}
                    className="ying"
                    src={data.yingyang.artist1.artwork}
                    alt="read"
                  />
                  <motion.img
                    key="yang"
                    initial={{ opacity: 0, x: "-100%" }}
                    animate={{ opacity: 1, x: "0%" }}
                    exit={{ opacity: 1, x: "-100%" }}
                    transition={{
                      duration: 1.0,
                      delay: 1.5,
                      ease: [0, 0.71, 0.2, 1.01],
                    }}
                    className="yang"
                    src={data.yingyang.artist2.artwork}
                    alt="read"
                  />
                </motion.div>

                <motion.h1
                  key="step-4h2-key"
                  initial={{ opacity: 0, y: "100%" }}
                  animate={{ opacity: 1, y: "0%" }}
                  exit={{ opacity: 1, y: "-100%" }}
                  transition={{
                    duration: 1.0,
                    delay: 1.5,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className="curiosity-artist-name"
                >
                  {data.yingyang.artist2.name}
                </motion.h1>
              </div>

              <div className="column-layout yy-bottom-content">
                <motion.p
                  key="step-4ht-key"
                  initial={{ opacity: 0, y: "100%" }}
                  animate={{ opacity: 1, y: "0%" }}
                  exit={{ opacity: 1, y: "-100%" }}
                  transition={{
                    duration: 1.0,
                    delay: 4.5,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                >
                  ok... eclectic music taste!!
                </motion.p>
                <motion.button
                  key="step-4bt-key"
                  initial={{ opacity: 0, y: "100%" }}
                  animate={{ opacity: 1, y: "0%" }}
                  exit={{ opacity: 1, y: "-100%" }}
                  transition={{
                    duration: 1.0,
                    delay: 6.5,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  onClick={next}
                >
                  <ActionButtonFull title={"next"} />
                </motion.button>
              </div>
            </motion.div>
          </div>
        );
      case "comeback-message":
        return (
          <ComebackMessage
            featureText="Come back tomorrow to unlock your next stat: Your Airbuds Yearly Recap: shareable asset version 😏"
            next={() => {}}
          />
        );
      default:
        return <ShareableComponent />;
    }
  };

  return (
    <div className={"app-stats-container curiosity-gradient-background "}>
      {renderState(refCategories.current, step)}
      <StoryOverlay className={""} prev={previous} next={next} />
      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
      />
      <StoryProgressBar
        className="story-bar"
        totalPages={categories.length}
        currentPage={step}
        duration={0}
      />
    </div>
  );
};
